import { usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation>[3];

export const useLogout = (config: Config) => {
  return usePostMutation(z.undefined(), z.null(), "/console/logout", config);
};
